module.exports = "//d274d294w9cx2v.cloudfront.net/5ab3b12b61c448d1ccdd8f69f7d6b8010f227db4/images/photo-single.png";